import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AmbienteService } from './api-ambiente.service';

@Injectable({
  providedIn: 'root'
})
export class AmbienteDataService {
  constructor(private api: AmbienteService) {}

  public GetAmbiente(): Observable<any> {
    return this.api.GetAmbiente();
  }
}
